<template>
  <mf-button v-if="url" :label="label" text icon="download" color="marca-0-l40" @click="downloadFile" />
</template>

<script>
export default {
  name: 'DownloadFileButton',
  props: {
    url: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Baixar arquivo',
    },
  },
  methods: {
    downloadFile() {
      const link = document.createElement('a')
      link.href = this.url
      link.setAttribute('target', '_blank')
      link.click()
    },
  },
}
</script>
